module.exports = __webpack_public_path__ + "img/icon-地理@2x.7ac1c4b3.png";